import { CostPriceModel } from './CostPriceModel';
import { CupLidType, cupLidTypeOrdinals } from './CupLidType';
import { ReceiptTransactionDate } from './ReceiptTransactionDate';
import { RecentActivityPeriod } from './RecentActivityPeriod';

/**
 * Dropdown definitions that map onto a typed enum. The enum names the options the screen offers and
 * labels a stored value where no locale label exists; the server still accepts every value in the
 * definition's allowed list, including ordinals older rows may hold.
 */
const dropdownEnums: Record<string, Record<string, string>> = {
  CostPriceModel,
  ReceiptTransactionDate,
  RecentActivityPeriod,
  CupLidType,
};

const aliases: Record<string, Record<string, string>> = {
  CupLidType: cupLidTypeOrdinals,
};

export const dropdownOptions = (name: string, allowedValues: readonly string[]): string[] => {
  const enumeration = dropdownEnums[name];
  if (!enumeration) return [...allowedValues];
  const values = Object.values(enumeration);
  return values.filter(value => allowedValues.includes(value));
};

export const enumLabel = (name: string, value: string): string | undefined => {
  const enumeration = dropdownEnums[name];
  if (!enumeration) return undefined;
  const canonical = aliases[name]?.[value] ?? value;
  return Object.keys(enumeration).find(key => enumeration[key] === canonical);
};
